var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 3,
    y: 3,
    width: 34,
    height: 34,
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Icons_MaleProfile",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 66C79.9478 63.4946 78.773 61.1451 76.8 59.6 72.4 56 66.8 53.6 61.2 52 56.9217 50.6903 52.4742 50.0165 48 50 43.5307 50.0771 39.0916 50.7497 34.8 52 29.2073 53.632 23.9323 56.2019 19.2 59.6 17.227 61.1451 16.0522 63.4946 16 66L16 82 80 82Z",
    stroke: "#000000",
    strokeWidth: 0.999905,
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 25.75C47.6 24.22 54 19.28 54 19.28L54 19.28C55.0099 19.3675 55.9708 19.7539 56.76 20.39 58.6805 21.7385 60.3068 23.4635 61.54 25.46 62.65 27.12 63.6 28.46 63.89 28.86L63.89 28.86 64 29 64 29C64.5 28 64.48 25.21 64.13 22.67 63.64 19.17 63.24 18.13 61 16.25 59.5727 14.9565 57.6679 14.3215 55.75 14.5 53.1478 12.4807 50.0131 11.2644 46.73 11 41.73 10.82 36.27 13.43 33.95 16.49 30.44 21.09 30.83 24.09 30.83 25.16 30.83 26.23 29.6 28.09 30.46 28.09 31.02 28.09 31.57 28.09 32.13 28.09L32.13 28.09C35.3 28 41.77 27.65 45 25.75Z",
    stroke: "#000000",
    strokeWidth: 0.999905,
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.42 30.17C62.37 30.1 61.27 28.57 59.93 26.58 58.8295 24.7751 57.3692 23.216 55.64 22 55.3034 21.7549 54.9372 21.5533 54.55 21.4 52.77 22.75 48.19 26.19 46.01 27.46 42.55 29.46 36.24 29.99 32.01 30.08 32.1196 38.9159 39.3713 45.9899 48.2072 45.8803 56.0992 45.7825 62.7409 39.9443 63.85 32.13Z",
    stroke: "#000000",
    strokeWidth: 0.999905,
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.61cbf12d7678edd322dbdc88869f77a4.svg";
export { ForwardRef as ReactComponent };